import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Content from '/src/data/auto-generated/pagebuilder/lib/ContentTypes/Html/html.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "html-code"
    }}>{`HTML Code`}</h1>
    {/*
     The reference doc content is generated automatically from the source code.
     To update this section, update the doc blocks in the source code
     */}

    <Content mdxType="Content" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      